import { apiClient } from './api-client'
import type { CodeOption } from '@/src/types/api.types'

// ─── Localizzazione Geografica ───────────────────────────────────────────────

export function getRegioni(lang: string) {
  return apiClient.get<CodeOption[]>('/codes/regioni', { lang })
}

export function getProvince(regioneId: string, lang: string) {
  return apiClient.get<CodeOption[]>(`/codes/province/${regioneId}`, { lang })
}

export function getComuni(provinciaId: string, lang: string) {
  return apiClient.get<CodeOption[]>(`/codes/comuni/${provinciaId}`, { lang })
}

export function getCountries(lang: string) {
  return apiClient.get<CodeOption[]>('/codes/country', { lang })
}

// ─── Istruzione ──────────────────────────────────────────────────────────────

export function getIstituti(lang: string) {
  return apiClient.get<CodeOption[]>('/codes/istituti', { lang })
}

export function getUniversita(lang: string) {
  return apiClient.get<CodeOption[]>('/codes/universita', { lang })
}

export function getAreeDisciplinari(lang: string) {
  return apiClient.get<CodeOption[]>('/codes/areadisciplinare', { lang })
}

export function getAnnoCorso(lang: string) {
  return apiClient.get<CodeOption[]>('/codes/annocorso', { lang })
}

export function getTipologieLaurea(lang: string) {
  return apiClient.get<CodeOption[]>('/codes/tipologialaurea', { lang })
}

export function getAnniLaurea(tipoLaurea: string) {
  return apiClient.get<CodeOption[]>(`/codes/tipolaureaanno/${tipoLaurea}`)
}

// ─── Lavoro / Famiglia ──────────────────────────────────────────────────────

export function getTitoliStudio(lang: string) {
  return apiClient.get<CodeOption[]>('/codes/padretitolostudio', { lang })
}

export function getProfessioni(lang: string) {
  return apiClient.get<CodeOption[]>('/codes/padreprofessione', { lang })
}

export function getAreeProfessionali(lang: string) {
  return apiClient.get<CodeOption[]>('/codes/padreareaprofessionale', { lang })
}

export function getStatusGenitore(lang: string) {
  return apiClient.get<CodeOption[]>('/codes/padrestatus', { lang })
}

export function getStatoCivile(lang: string) {
  return apiClient.get<CodeOption[]>('/codes/statocivile', { lang })
}

export function getFasceIsee(lang: string) {
  return apiClient.get<CodeOption[]>('/codes/fasciaisee', { lang })
}

// ─── Questionario / Interessi ────────────────────────────────────────────────

export function getConoscenzaCamplus(lang: string) {
  return apiClient.get<CodeOption[]>('/codes/conoscenzacamplus', { lang })
}

export function getTempoLibero(lang: string) {
  return apiClient.get<CodeOption[]>('/codes/tempolibero', { lang })
}

// ─── Disponibilità ──────────────────────────────────────────────────────────

export function getAvailableStructures(
  cityId: string,
  checkin: string,
  params: { gender: string; target: 'studenti' | 'lavoratori'; lang: string }
) {
  return apiClient.get<CodeOption[]>(`/codes/disponibilita/structures/${cityId}/${checkin}`, params)
}

export function getAvailableRooms(
  sedeId: string,
  checkin: string,
  durata: string,
  params: { gender: string; lang: string; tipologia?: string }
) {
  return apiClient.get<CodeOption[]>(
    `/codes/disponibilita/rooms/${sedeId}/${checkin}/${durata}`,
    params
  )
}

// ─── Annunci / Tariffe ──────────────────────────────────────────────────────

export function getAnnunci(lang: string, perPage = 1000) {
  return apiClient.get<CodeOption[]>('/codes/annunci', { lang, per_page: String(perPage) })
}
